import { render, staticRenderFns } from "./SelectProp.vue?vue&type=template&id=1b0ce02a&"
import script from "./SelectProp.vue?vue&type=script&lang=js&"
export * from "./SelectProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports